import { Lead } from '../../../types';
import { sendWonConversions } from '../../../services/modules/leadTrackingService';

/**
 * Side effects ao marcar lead como ganho: valor em lead_tracking + Meta/Google.
 */
export const handleWonLeadTracking = async (lead: Lead, organizationId: string) => {
    if (!organizationId || lead.value <= 0) return;

    try {
        await sendWonConversions(lead.id, lead.value, organizationId, lead.contactId);
    } catch (trackingError) {
        console.error('[LeadTrackingHelper] Erro no fluxo de tracking de ganhar:', trackingError);
    }
};
